import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { IsNavigationExpandedCache } from "@webapp/navigation/services/is-navigation-expanded.cache";

@UntilDestroy()
@Component({
  selector: "top-nav-bar",
  templateUrl: "./top-nav-bar.component.html",
  styleUrls: ["./top-nav-bar.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopNavBarComponent implements OnInit {
  @Input()
  public navTitle: string;

  @Input()
  public navSubTitle: string;

  @Input()
  public showFavIcon = false;

  @Input()
  public showTabs = false;

  @Input()
  public showDropdown = false;

  @Input()
  public showButtons = false;

  @Input()
  public isGrayBackground = false;

  public isNavExpanded = false;

  constructor(private isNavExpandedCache: IsNavigationExpandedCache, private cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.isNavExpandedCache
      .get$()
      .pipe(untilDestroyed(this))
      .subscribe((isNavExpanded) => {
        this.isNavExpanded = isNavExpanded;
        this.cdr.markForCheck();
      });
  }

  @HostBinding("class.gray-background")
  public get backgroundClass(): boolean {
    return this.isGrayBackground;
  }
}
